import styled from '@emotion/styled'

export const IllustrationWrapper = styled.div`
  margin: 0 auto;
`

export const FooterContentWrapper = styled.div`
  width: 100%;
`
